import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { FormControl, FormLabel } from '@mui/material';
import { setLocationDisplayOption as sldo } from '../../../redux/actions/ui';
import Selector from '../../util/Selector';

import './filters.css';

const OPTIONS = [
  { key: 'flow', id: 'flow', display: 'Operational Flow' },
  { key: 'physlocation', id: 'physlocation', display: 'Physical Location' },
  { key: 'areaserved', id: 'areaserved', display: 'Area Served' },
];

const ByLocOptionsView = ({ value, handleChange }) => (
  <FormControl component="fieldset" className="filter-outer">
    <FormLabel component="legend" className="legend">
      Sort By:
    </FormLabel>
    <Selector options={OPTIONS} selected={value} onChange={handleChange} />
  </FormControl>
);

ByLocOptionsView.propTypes = {
  value: PropTypes.string.isRequired,
  handleChange: PropTypes.func.isRequired,
};

export default connect(
  ({ ui: { byLocDisplayOption } }) => ({
    value: byLocDisplayOption,
  }),
  (dispatch) => ({
    handleChange: (e) => dispatch(sldo(e.target.value)),
  })
)(ByLocOptionsView);
